export function vendorTypeIcon(type) {
  switch (type) {
    case "Realtor":
      return "🏠";
    case "Broker":
      return "🔑";
    case "Photographer":
      return "📷";
    case "Property Manager":
      return "🏢";
    case "Contractor":
      return "🔨";
    case "Legal":
      return "⚖️";
    case "Lender":
      return "🏦";
    case "Inspector":
      return "🔍";
    case "Appraiser":
      return "📋";
    default:
      return "📌";
  }
}

export function vendorTypeColor(type) {
  switch (type) {
    case "Realtor":
      return "#0d9488";
    case "Broker":
      return "#2563eb";
    case "Photographer":
      return "#7c3aed";
    case "Property Manager":
      return "#ea580c";
    case "Contractor":
      return "#4f46e5";
    case "Legal":
      return "#64748b";
    case "Lender":
      return "#d97706";
    case "Inspector":
      return "#0891b2";
    case "Appraiser":
      return "#db2777";
    default:
      return "#64748b";
  }
}

export function vendorDisplayName(vendor = {}) {
  const person =
    vendor.primaryContactName ||
    [vendor.primaryContactFirstName, vendor.primaryContactLastName].filter(Boolean).join(" ").trim();
  return person || vendor.vendorName || "Professional";
}

export function vendorCompanyLine(vendor = {}) {
  const display = vendorDisplayName(vendor);
  const business = vendor.vendorName || "";
  if (display !== business && business) {
    return business;
  }
  return "";
}

export function vendorInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "—";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
}

export function formatWebsiteLabel(url) {
  if (!url) return "";
  return String(url).replace(/^https?:\/\//i, "").replace(/\/$/, "");
}
